import React, { useEffect, useState } from "react"
import axios from "axios"
import Grid from '@material-ui/core/Grid';
import Layout from "../components/layout"
import PremiumServices from "../components/Sidebar/PremiumServices"
import Seo from "../components/seo"
import Loading from "./loading"

const LiveWeatherObservations = () => {

  const [data, setData] = useState([])
  const [url] = useState(process.env.MET_LIVEWEATHEROBSERVATIONS)
  const [loading, setloading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      setError(false)
      setloading(true)
      try {
        const result = await axios(url)
        setData(result.data.liveWeatherObservations)
      } catch (error) {
        setError(true)
        console.log(error)
      }
      setloading(false)
    }
    fetchData()
  }, [url])

      return (
          <React.Fragment>
            <Layout>
            <Seo title="Live weather observations for Jersey" description="Live weather observation data from Jersey’s Maison St Louis Observatory" />
            <div className="forecastAutoMargin">
            <Grid item xs={12} sm={12} md={8} lg={8} className="menuTitle" style={{paddingLeft:0}}>
                  <h1>
                  Weather observations
                  </h1>                  
            </Grid>
              <Grid container spacing={2}>
                  <Grid  item xs={12} sm={12} md={8} lg={8}>
                  <React.Fragment>
                  <div className="Content">
                  {error ? (
                <React.Fragment>
                  <div>
                    <p style={{ color: "#bf0d0d" }}>Live Weather Observations data unavailable</p>
                  </div>
                </React.Fragment>
              ) : loading ? (
                <Loading />
              ) : (
                data.map((result, index) => (     
                  <>
                  <img key={index} style={{maxWidth:"600px", display:"block", margin:"auto"}} src={result.ImageUrl}/>
                  <p>{result.Comment}</p>
                  </> 
                ))
           
              )}
              </div>
                  </React.Fragment>
                  </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4}>
                        <PremiumServices/>
                      </Grid>
              </Grid>
              </div>
            </Layout>
          </React.Fragment>
      )
  }
  export default LiveWeatherObservations;